import { render, staticRenderFns } from "./GuideBox.vue?vue&type=template&id=9c773a62&scoped=true"
import script from "./GuideBox.vue?vue&type=script&lang=js"
export * from "./GuideBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c773a62",
  null
  
)

export default component.exports